export default "__VITE_ASSET__Bzf3KDQJ__"